<template>
  <div id="notes">
    <div
      class="uk-section uk-section-secondary uk-light uk-margin uk-margin-remove"
    >
      <div class="uk-container">
        <h1>Notes</h1>
        <div class="uk-grid-match uk-child-width-1-2@m" uk-grid>
          <div>
            <h5>
              Tips, tricks, hints, hacks. The notes I have made are not a diary
              in the ordinary sense, but partly lengthy records of my
              technological and spiritual evolution, and partly poems in prose.
            </h5>
          </div>
        </div>
      </div>
    </div>

    <div
      class="uk-container uk-container-expand uk-margin uk-margin-small uk-padding uk-padding-large"
    >
      <div
        class="uk-child-width-1-2@m uk-grid uk-grid-small uk-grid-match"
        uk-grid
        uk-scrollspy="cls: uk-animation-fade; target: .uk-card; delay: 100; repeat: true"
      >
        <div v-for="card in cards" v-bind:key="card.id">
          <NoteCards
            :description="card.description"
            :items="card.items"
            :label="card.label"
            :stack="card.stack"
            :name="card.name"
            :link="card.link"
          ></NoteCards>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoteCards from "./NoteCards.vue";

export default {
  name: "NoteSection",
  components: { NoteCards },
  data() {
    return {
      cards: [
        {
          id: 1,
          name: "KaliBook",
          label: "LINUX",
          stack: "shell, Kali Linux, MacBook Air 7,2",
          description: "Some notes on running Kali Linux on MacBook Air 7,2.",
          link: "https://github.com/ronitrex/KaliBook",
          items: [
            {
              id: 1,
              title:
                "Kali Linux has introduced significant changes going into 2020. The default root user nature of previous versions of Kali made it unsuitable for daily use. They have introduced a new theme based on Gnome, and most importantly the default user is no longer root.",
            },
            {
              id: 2,
              title:
                "With recent kernel upgrades, the MacBooks without the TouchBar now have complete support in the Linux kernel. This makes the MacBook Air 7,2 a unique machine. It's old enough that it is now well supported.",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
h1,
h5 {
  font-family: "overpass", sans-serif;
  font-weight: 600;
  font-style: normal;
}
</style>
